module.exports = __webpack_public_path__ + "img/Patent_3.c647e729.png";